import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HolidayService } from 'app/core/services/holiday.service';
import { RefreshHolidayService } from 'app/core/services/refresh-holiday/refresh-holiday.service';

@Component({
  selector: 'dialog-delete-holiday',
  templateUrl: './dialog-delete-holiday.component.html',
  styleUrls: ['./dialog-delete-holiday.component.scss']
})
export class DialogDeleteHolidayComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeleteHolidayComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private holidayService: HolidayService,
    private refreshHolidayService: RefreshHolidayService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteHoliday() {
    this.isLoading = true;
    this.holidayService.deleteHoliday(this.data.id).subscribe({
      next: (res) => {
        this.refreshHolidayService.emitRefresh(this.data.index);
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: (err) => {
        this.isLoading = true;
        console.error('Error deleting category:', err);
      },
    });
  }
}
